// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","root":"root-1LI9e","deleteButton":"deleteButton-1eisx"};